module.exports = __webpack_public_path__ + "static/img/S124WP_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/S124WP_1.png
// module id = IS1U
// module chunks = 0